import { render, staticRenderFns } from "./Accordion2.vue?vue&type=template&id=6cc73203&scoped=true&"
import script from "./Accordion2.vue?vue&type=script&lang=js&"
export * from "./Accordion2.vue?vue&type=script&lang=js&"
import style0 from "./Accordion2.vue?vue&type=style&index=0&id=6cc73203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc73203",
  null
  
)

export default component.exports